/**
 * @generated SignedSource<<4e69a0370810e5a0635145a09fbb6bb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicsCardTopicSearchEdge$data = ReadonlyArray<{
  readonly node: {
    readonly content: {
      readonly entityId: string;
      readonly " $fragmentSpreads": FragmentRefs<"itemTopicsCardItemTopic">;
    } | null | undefined;
  };
  readonly " $fragmentType": "topicsCardTopicSearchEdge";
}>;
export type topicsCardTopicSearchEdge$key = ReadonlyArray<{
  readonly " $data"?: topicsCardTopicSearchEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicsCardTopicSearchEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "topicsCardTopicSearchEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TopicSearchResultItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "itemTopicsCardItemTopic"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TopicSearchEdge",
  "abstractKey": null
};

(node as any).hash = "cd4256c172596b9043b3a68d7f84d4d9";

export default node;
